import { app } from '../../../../../app';

class SmsResetPin {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    sendResetPinCode(companyId, companyUserId) {
        const url = `app/rest/companies/${companyId}/companyusers/${companyUserId}/sendResetPinCode`;
        return this.$http.post(url).then(({data}) => data);
    }
}

app.service('SmsResetPin', SmsResetPin);



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/sms-reset-pin/sms-reset-pin.service.js